// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-c30cdfe4]{position:absolute;border-bottom:none;padding:0}", ""]);
// Exports
module.exports = exports;
